module.exports = __webpack_public_path__ + "img/icon-sb-in-home-drop-off-icon-160x120-v1.b32cd69.svg";